import React from 'react';

function Tabs(props) {

  return (
    <div className="recharge-tabs-container">
      <div className="map-container-selector font10">
        <div
          className={'selector-item ' + (props.selectedTab == 1 ? 'active' : '')}
          onClick={() => props.onTabChange(1)}
          style={{background:props.selectedTab == 1 ? props.operator && props.operator.color_codes.account_tab_color : ''}}
        >
          {props.t('PROFILE.CASH')}
        </div>
        <div
          className={'selector-item ' + (props.selectedTab == 2 ? 'active' : '')}
          onClick={() => props.onTabChange(2)}
          style={{background:props.selectedTab == 2 ? props.operator && props.operator.color_codes.account_tab_color : ''}}
        >
          {props.t('PROFILE.BANK_TRANSFER')}
        </div>
      </div>
    </div>
  );
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKupospayRecharge/components/Tabs.js